<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<mat-toolbar class="display-flex-toolbar">
	<div class="title-container">
		<i mat-icon-button class="material-icons" *ngIf="showIcon"
			><span>{{ iconName }}</span></i
		>
		<span class="ticket-title" automationId="ticketTitle">{{ title }}</span>
	</div>
	<button
		mat-icon-button
		class="select-button"
		type="button"
		automationId="closeButton"
		(click)="onClicked($event)"
	>
		<i class="material-icons"><span>clear</span></i>
	</button>
</mat-toolbar>
